<template>
  <el-dialog @open="iniciar" title="Selecionar Imobiliária Pré Cadastrada" :visible.sync="visibility" :before-close="cancelar" :close-on-click-modal="false" :modal-append-to-body="false" width="700px">
    <el-form label-position="top" size="small" @submit.native.prevent>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Razão Social">
            <el-input v-model="imobiliariaPesquisa.razaoSocial" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row :gutter="10">
      <el-col :span="24">
        <el-table
          @row-dblclick="doubleClickCellImobiliaria"
          @current-change="changeImobiliariaSelecionada"
          :data="imobiliarias"
          empty-text="Nenhuma Imobiliária"
          height="300"
          highlight-current-row
          stripe
        >
          <el-table-column label="ID" width="60" prop="id" />
          <el-table-column label="Nome" prop="razaoSocial" show-overflow-tooltip />
        </el-table>
      </el-col>
    </el-row>
    
    <span slot="footer">
      <el-button @click="clickBotaoSelecionar" size="mini" type="success">
        Selecionar
      </el-button>
      <el-button @click="clickBotaoFechar" size="mini" type="danger">
        Fechar
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    visibility: Boolean,
  },

  data() {
    return {
      imobiliariasRecuperadas: [],

      imobiliariaPesquisa: {
        razaoSocial: '',
      },

      imobiliariaSelecionada: {
        id: 0,
      },
    };
  },

  computed: {
    imobiliarias() {
      return this.imobiliariasRecuperadas
        .filter(this.filterByRazaoSocial);
    },
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading',
    ]),

    ...mapActions('imobiliariasStore', {
      'listarImobiliariasAction': 'listarImobiliariasPreCadastradas',
    }),

    clickBotaoSelecionar() {
      if(this.imobiliariaSelecionada.id === 0) {
        return;
      }
      this.selecionarImobiliaria(this.imobiliariaSelecionada);
    },

    changeImobiliariaSelecionada(imobiliaria) {
      this.imobiliariaSelecionada = imobiliaria;
    },

    doubleClickCellImobiliaria(imobiliaria) {
      this.selecionarImobiliaria(imobiliaria);
    },

    selecionarImobiliaria(imobiliaria) {
      this.$emit('selecionar', imobiliaria);
    },

    clickBotaoFechar() {
      this.close();
    },

    iniciar() {
      this.reset();
      this.listarImobiliarias();
    },

    listarImobiliarias() {
      this.showLoading();

      const payload = {};
      
      this.listarImobiliariasAction(payload)
        .then(resultado => {
          if(resultado.status === 'SUCESSO') {
            this.imobiliariasRecuperadas = [ ...resultado.lista ];
          }
        })
        .catch()
        .finally(() => {
          this.hideLoading();
        });
    },

    filterByRazaoSocial(imobiliaria) {
      if(!imobiliaria.razaoSocial) {
        return true;
      }

      const search = this.imobiliariaPesquisa.razaoSocial.trim().toLowerCase();
      const razaoSocial = imobiliaria.razaoSocial.toLowerCase();

      return razaoSocial.includes(search);
    },

    reset() {
      this.resetForm();
    },

    resetForm() {
      this.imobiliariaPesquisa = {
        razaoSocial: '',
      };

      this.imobiliariaSelecionada = {
        id: 0,
      };
    },

    cancelar() {
      this.close();
    },

    close() {
      this.$emit('close');
    },
  },
}
</script>

<style>

</style>